import React from 'react'
import { IconProps } from '../../../common/types'

const ImportsIcon: React.FC<IconProps> = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25">
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M12 2.688v7l2-2M12 9.688l-2-2M1.98 13.688h4.41c.38 0 .72.21.89.55l1.17 2.34a2 2 0 0 0 1.79 1.11h3.53a2 2 0 0 0 1.79-1.11l1.17-2.34a1 1 0 0 1 .89-.55h4.36"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M7 4.817c-3.54.52-5 2.6-5 6.87v4c0 5 2 7 7 7h6c5 0 7-2 7-7v-4c0-4.27-1.46-6.35-5-6.87"
      ></path>
    </svg>
  )
}

export default ImportsIcon
